// Promotions-specific table state mappings
import { getSingleValue } from '@/lib/utils/table-state-utils';

export const promotionsFilterMapping = {
    name: (value: any) => {
        const searchValue = getSingleValue(value);
        return searchValue ? { 'promotions.name': { value: searchValue, condition: 'contains' as const } } : undefined;
    },
};

export const promotionsQueryParamsMapping = {
    name: (value: URLSearchParams) => {
        return value.get('name');
    },
};

// Sort field mappings for promotions (frontend column ID -> backend sort field)
export const promotionsSortMapping = {
    id: 'createdAt' as const,
    name: 'name' as const,
    status: 'enabled' as const,
    enabled: 'enabled' as const,
    dates: 'startDate' as const,
    startDate: 'startDate' as const,
    endDate: 'endDate' as const,
    usage: 'usageCount' as const,
    usageCount: 'usageCount' as const,
    usageLimit: 'usageLimit' as const,
    createdAt: 'createdAt' as const,
} as const;

